<template>
  <p class="w-full p-3 rounded-md bg-white text-sm text-center font-medium">
    <slot />
  </p>
</template>
